module.exports = __webpack_public_path__ + "assets/map_background.jpg";


//////////////////
// WEBPACK FOOTER
// ./libs/images/map_background.jpg
// module id = 354
// module chunks = 0